<div class="align-right">
  <button mat-button color="primary" (click)="addWeeeSystem()">
    <mat-icon>add_circle_outline</mat-icon>
    <span> add </span>
  </button>
</div>
<div class="table-container">
  <table mat-table [dataSource]="weeeSystems" matSort>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.weee-system.name" |translate}}</th>
      <td mat-cell *matCellDef="let ws">{{ws.description}}</td>
    </ng-container>

    <ng-container matColumnDef="country.name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.countries.country" |translate}} {{"admin.countries.name" |translate}}</th>
      <td mat-cell *matCellDef="let ws">{{ws.country.name}}</td>
    </ng-container>

    <ng-container matColumnDef="member">
      <th mat-header-cell *matHeaderCellDef>{{"admin.weee-system.member" |translate}}</th>
      <td mat-cell *matCellDef="let ws">
        <mat-icon *ngIf="ws.isMember">check</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let ws">
        <mat-icon (click)="editWeeeSystem(ws)" color="primary"
                  matTooltip="Edit" matTooltipPosition="above">edit
        </mat-icon>
        <mat-icon *ngIf="ws.status === 'ACTIVE'" color="primary"
                  matTooltip="Disable" matTooltipPosition="above"
                  (click)="updateWeeeSystem(ws, false)">check_circle
        </mat-icon>
        <mat-icon *ngIf="ws.status === 'INACTIVE'"
                  color="primary" matTooltip="Enable" matTooltipPosition="above"
                  (click)="updateWeeeSystem(ws, false)">radio_button_unchecked
        </mat-icon>
        <mat-icon *ngIf="ws.status === 'INACTIVE'"
                  color="primary" matTooltip="Delete" matTooltipPosition="above"
                  (click)="updateWeeeSystem(ws, true)">delete
        </mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>
